export default {
  alpha: {
    isValidated: null,
  },
};
